export const getSettings = () => {
	try {
		const raw = localStorage.getItem("ChettiToolsSettings");

		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};
export const defaultReportArray = {
	Performance_Summary_Total: {
		customizable: false,
		reportIds: 1,
		inReport: true,
		sortBy: "Sales",
		limit: 1,
		headers: {
			"Merchant Id": { yoy: false, dataType: "string", display: false },
			Merchant: { yoy: false, dataType: "string", display: false },

			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency", display: true },
			Commissions: { yoy: true, dataType: "currency", display: true },
			"Incentives ": { yoy: true, dataType: "currency", display: true },
			"Network Commissions": {
				yoy: true,
				dataType: "currency",
				display: true,
			},
			"# of Sale": { yoy: true, dataType: "int", display: true },
			"# of Adjustment": { yoy: true, dataType: "int", display: true },

			"New Customers": { yoy: false, dataType: "int", display: true },
			"New Customer Sales": {
				yoy: true,
				dataType: "currency",
				display: true,
			},

			"Conversion Rate": { yoy: true, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
		},
	},

	Product_Sold_List: {
		customizable: false,
		reportIds: 18,
		inReport: true,
		sortBy: "Total Product Sale Quantity",
		joinKey: "Product Name",
		headers: {
			"Product Name": { yoy: false, dataType: "string" },
			"Product SKU": { yoy: false, dataType: "string" },
			"Sale Count ": { yoy: true, dataType: "currency" },
			"Total Product Sale Amount": { yoy: true, dataType: "currency" },
		},
	},
	Performance_Summary_By_Day_Graph: {
		reportIds: 12,
		inReport: true,
		headers: {
			"CPC Earnings": { yoy: true, dataType: "currency" },
			"Network CPC Earnings": { yoy: true, dataType: "currency" },
			Date: false,
			"Ad Impressions": { yoy: true, dataType: "int" },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency", display: true },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
			Merchant: { yoy: false, dataType: "string" },
			Weekday: { yoy: false, dataType: "string", display: true },
		},
	},
	Performance_Summary_By_Month: {
		reportIds: 48,
		inReport: true,
		ytd: true,
		customizable: false,
	},
	Product_Performance_By_Departments_and_Brands: {
		customizable: false,
		reportIds: 18,
		inReport: true,
		sortBy: "Total Product Sale Quantity",
		joinKey: "Product Name",
		headers: {
			"Brand Name": { yoy: false, dataType: "string" },
			Category: { yoy: false, dataType: "string" },
			Department: { yoy: false, dataType: "string" },
			Merchant: { yoy: false, dataType: "string" },
			"Product Name": { yoy: false, dataType: "string" },
			"Product SKU": { yoy: false, dataType: "string" },
			"Sale Count ": { yoy: true, dataType: "currency" },
			"Sub Category": { yoy: false, dataType: "string" },
			"Total Product Sale Amount": { yoy: true, dataType: "currency" },
			"Total Product Sale Quantity": { yoy: true, dataType: "int" },
		},
	},
	Performance_Summary_By_Affiliate: {
		id: 20,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Affiliate Id",
		headers: {
			"Affiliate Id": { yoy: false, dataType: "string" },
			"Website Category": { yoy: false, dataType: "string" },
			"Ad Impressions": { yoy: true, dataType: "int", display: true },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency" },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
			"Affiliate Tags": { yoy: false, dataType: "string" },
		},
	},
	Performance_Summary_By_Affiliate_Website: {
		id: 20,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Website Id",
		headers: {
			"Website Id": { yoy: false, dataType: "string" },
			"Affiliate Id": { yoy: false, dataType: "string" },
			"Affiliate Website Name": { yoy: false, dataType: "string" },
			"Affiliate Website": { yoy: false, dataType: "string" },
			"Website Category": { yoy: false, dataType: "string" },
			"Affiliate Category": { yoy: false, dataType: "string" },
			"Ad Impressions": { yoy: true, dataType: "int", display: true },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency" },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
		},
	},
	Performance_Summary_By_Sub_Affiliate_Website: {
		id: 20,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Website Id",
		headers: {
			"CPC Earnings": { yoy: true, dataType: "currency" },
			"Network CPC Earnings": { yoy: true, dataType: "currency" },
			"Placement Earnings": { yoy: true, dataType: "currency" },
			"Network Placement Earnings": { yoy: true, dataType: "currency" },
			"Website Id": { yoy: false, dataType: "string" },
			"Affiliate Id": { yoy: false, dataType: "string" },
			"Affiliate Website Name": { yoy: false, dataType: "string" },
			"Affiliate Website": { yoy: false, dataType: "string" },
			"Website Category": { yoy: false, dataType: "string" },
			"Affiliate Category": { yoy: false, dataType: "string" },
			"Ad Impressions": { yoy: true, dataType: "int", display: true },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency" },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
			"Affiliate Tags": { yoy: false, dataType: "string" },
		},
	},
	Custom_Performance_Summary_Array: {
		id: 20,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Website Id",
		headers: [
			{
				value: "Affiliate Name",
				format: "string",
				label: "Affiliate Name",
				comp: false,
				addClass: "",
			},
			{
				value: "Click Throughs",
				format: "int",
				label: "Click Throughs",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "# of Sales",
				format: "int",
				label: "# of Sales",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "Sales",
				format: "dollar",
				label: "Sales",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "Commissions",
				format: "dollar",
				label: "Commissions",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "Conversion Rate",
				format: "percent",
				label: "Conversion Rate",
				comp: true,
				addClass: "small-cell",
			},
			{
				value: "AOV",
				format: "dollar",
				label: "AOV",
				comp: true,
				addClass: "small-cell",
			},
		],
	},
};

export const _adminApiModules = {
	Performance_Summary: {
		id: 1,
		inReport: true,
		sortBy: "Sales",
		limit: 1,
		headers: {
			"Merchant Id": { yoy: false, dataType: "string", display: false },
			Merchant: { yoy: false, dataType: "string", display: false },
			"Ad Impressions": { yoy: true, dataType: "int", display: true },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency", display: true },
			Commissions: { yoy: true, dataType: "currency", display: true },
			"Incentives ": { yoy: true, dataType: "currency", display: true },
			"Network Commissions": {
				yoy: true,
				dataType: "currency",
				display: true,
			},
			"# of Sale": { yoy: true, dataType: "int", display: true },
			"# of Adjustment": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency", display: true },
			"New Customers": { yoy: false, dataType: "int", display: true },
			"New Customer Sales": {
				yoy: true,
				dataType: "currency",
				display: true,
			},
			"CPC Earnings": { yoy: true, dataType: "currency", display: false },
			"Network CPC Earnings": {
				yoy: true,
				dataType: "currency",
				display: false,
			},
			"Placement Earnings": {
				yoy: true,
				dataType: "currency",
				display: false,
			},
			"Network Placement Earnings": {
				yoy: true,
				dataType: "currency",
				display: false,
			},
			"Conversion Rate": { yoy: true, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
		},
	},
	// Performance_Summary_By_Ad_Campaign: {
	// 	id: 24,
	// 	inReport: false,
	// 	sortBy: "Sales",
	// 	joinKey: "Ad Id",
	// 	headers: {
	// 		"CPC Earnings": { yoy: true, dataType: "currency", display: false },
	// 		"Network CPC Earnings": {
	// 			yoy: true,
	// 			dataType: "currency",
	// 			display: false,
	// 		},
	// 		"Merchant Id": { yoy: false, dataType: "string", display: false },
	// 		Merchant: { yoy: false, dataType: "string", display: false },
	// 		"Ad Id": { yoy: false, dataType: "string" },
	// 		"Ad Campaign/Subscription": { yoy: false, dataType: "string" },
	// 		"Ad Type": { yoy: false, dataType: "string" },
	// 		"Ad Impressions": { yoy: true, dataType: "int", display: true },
	// 		"Click Throughs": { yoy: true, dataType: "int", display: true },
	// 		Sales: { yoy: true, dataType: "currency" },
	// 		"# of Sales": { yoy: true, dataType: "int", display: true },
	// 		"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
	// 		"Mobile Sales": { yoy: true, dataType: "currency" },
	// 		"# of Adjustments": { yoy: true, dataType: "int", display: true },
	// 		"New Customers": { yoy: true, dataType: "int", display: true },
	// 		"New Customer Sales": { yoy: true, dataType: "currency" },
	// 		Commissions: { yoy: true, dataType: "currency", display: true },
	// 		Incentives: { yoy: true, dataType: "currency", display: true },
	// 		"Network Commissions": { yoy: true, dataType: "currency" },
	// 		"Conversion Rate": { yoy: false, dataType: "percent" },
	// 		"New Customer %": { yoy: true, dataType: "percent" },
	// 		"Click Through Rate": { yoy: true, dataType: "percent" },
	// 	},
	// },

	Performance_Summary_By_Affiliate: {
		id: 15,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Affiliate Id",
		headers: {
			"CPC Earnings": { yoy: true, dataType: "currency", display: false },
			"Network CPC Earnings": {
				yoy: true,
				dataType: "currency",
				display: false,
			},
			"Placement Earnings": {
				yoy: true,
				dataType: "currency",
				display: false,
			},
			"Network Placement Earnings": {
				yoy: true,
				dataType: "currency",
				display: false,
			},
			"Affiliate Id": { yoy: false, dataType: "string", display: true },
			"Affiliate Name": { yoy: false, dataType: "string", display: true },
			Affiliate: { yoy: false, dataType: "string", display: false },
			"Ad Impressions": { yoy: true, dataType: "int", display: true },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency", display: true },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency", display: true },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: true },
			"New Customer Sales": {
				yoy: true,
				dataType: "currency",
				display: true,
			},
			Commissions: { yoy: true, dataType: "currency", display: true },
			Incentives: { yoy: true, dataType: "currency", display: true },
			"Network Commissions": {
				yoy: true,
				dataType: "currency",
				display: true,
			},
			"Conversion Rate": {
				yoy: false,
				dataType: "percent",
				display: true,
			},
			"Average Sale Amount": {
				yoy: true,
				dataType: "currency",
				display: true,
			},
			"New Customer %": { yoy: true, dataType: "percent", display: true },
			"Click Through Rate": {
				yoy: true,
				dataType: "percent",
				display: true,
			},
			Merchant: { yoy: false, dataType: "string", display: false },
			"Affiliate Tags": {
				yoy: false,
				dataType: "string",
				display: false,
			},
		},
	},

	Performance_Summary_By_Affiliate_Website: {
		id: 20,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Website Id",
		headers: {
			"CPC Earnings": { yoy: true, dataType: "currency" },
			"Network CPC Earnings": { yoy: true, dataType: "currency" },
			"Placement Earnings": { yoy: true, dataType: "currency" },
			"Network Placement Earnings": { yoy: true, dataType: "currency" },
			"Website Id": { yoy: false, dataType: "string" },
			"Affiliate Id": { yoy: false, dataType: "string" },
			"Affiliate Website Name": { yoy: false, dataType: "string" },
			"Affiliate Website": { yoy: false, dataType: "string" },
			"Website Category": { yoy: false, dataType: "string" },
			"Affiliate Category": { yoy: false, dataType: "string" },
			"Ad Impressions": { yoy: true, dataType: "int", display: true },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency" },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
			"Affiliate Tags": { yoy: false, dataType: "string" },
		},
	},

	Performance_Summary_By_Day: {
		id: 12,
		inReport: true,
		headers: {
			"CPC Earnings": { yoy: true, dataType: "currency" },
			"Network CPC Earnings": { yoy: true, dataType: "currency" },
			Date: false,
			"Ad Impressions": { yoy: true, dataType: "int" },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency", display: true },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
			Merchant: { yoy: false, dataType: "string" },
			Weekday: { yoy: false, dataType: "string", display: true },
		},
	},
	Performance_Summary_By_Month: {
		id: 48,
		inReport: true,
		ytd: true,
		customizable: false,
		hAxisTitle: "Month",
	},
	// Performance_Summary_By_Hour: {
	// 	id: 29,
	// 	inReport: false,
	// 	headers: {
	// 		"CPC Earnings": { yoy: true, dataType: "currency" },
	// 		"Network CPC Earnings": { yoy: true, dataType: "currency" },
	// 		"Time of Day": { yoy: false, dataType: "string" },
	// 		"Ad Impressions": { yoy: true, dataType: "int" },
	// 		"Click Throughs": { yoy: true, dataType: "int", display: true },
	// 		Sales: { yoy: true, dataType: "currency" },
	// 		"# of Sales": { yoy: true, dataType: "int", display: true },
	// 		"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
	// 		"Mobile Sales": { yoy: true, dataType: "currency" },
	// 		"# of Adjustments": { yoy: true, dataType: "int", display: true },
	// 		"New Customers": { yoy: true, dataType: "int", display: false },
	// 		"New Customer Sales": { yoy: true, dataType: "currency" },
	// 		Commissions: { yoy: true, dataType: "currency" },
	// 		Incentives: { yoy: true, dataType: "currency", display: true },
	// 		"Network Commissions": { yoy: true, dataType: "currency" },
	// 		"Conversion Rate": { yoy: false, dataType: "percent" },
	// 		"Average Sale Amount": { yoy: true, dataType: "currency" },
	// 		"New Customer %": { yoy: true, dataType: "percent" },
	// 		"Click Through Rate": { yoy: true, dataType: "percent" },
	// 		Merchant: { yoy: false, dataType: "string" },
	// 	},
	// },
	// Performance_Summary_By_Month: {
	// 	id: 48,
	// 	inReport: false,
	// 	headers: {
	// 		"CPC Earnings": { yoy: true, dataType: "currency" },
	// 		"Network CPC Earnings": { yoy: true, dataType: "currency" },
	// 		Month: { yoy: false, dataType: "string" },

	// 		"Ad Impressions": { yoy: true, dataType: "int" },
	// 		"Click Throughs": { yoy: true, dataType: "int", display: true },
	// 		Sales: { yoy: true, dataType: "currency" },
	// 		"# of Sales": { yoy: true, dataType: "int", display: true },
	// 		"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
	// 		"Mobile Sales": { yoy: true, dataType: "currency" },
	// 		"# of Adjustments": { yoy: true, dataType: "int", display: true },
	// 		"New Customers": { yoy: true, dataType: "int", display: false },
	// 		"New Customer Sales": { yoy: true, dataType: "currency" },
	// 		Commissions: { yoy: true, dataType: "currency" },
	// 		Incentives: { yoy: true, dataType: "currency", display: true },
	// 		"Network Commissions": { yoy: true, dataType: "currency" },
	// 		"Conversion Rate": { yoy: false, dataType: "percent" },
	// 		"Average Sale Amount": { yoy: true, dataType: "currency" },
	// 		"New Customer %": { yoy: true, dataType: "percent" },
	// 		"Click Through Rate": { yoy: true, dataType: "percent" },
	// 		Merchant: { yoy: false, dataType: "string" },
	// 		Weekday: { yoy: false, dataType: "string" },
	// 	},
	// },
	// Performance_Summary_By_Product_Ad_Tools: {
	// 	id: 31,
	// 	inReport: false,
	// 	sortBy: "Sales",
	// 	headers: {
	// 		"CPC Earnings": { yoy: true, dataType: "currency" },
	// 		"Network CPC Earnings": { yoy: true, dataType: "currency" },
	// 		"Merchant Id": { yoy: false, dataType: "string" },
	// 		Merchant: { yoy: false, dataType: "string" },
	// 		"Product Name": { yoy: false, dataType: "string" },
	// 		"Product SKU": { yoy: false, dataType: "string" },
	// 		"Ad Impressions": { yoy: true, dataType: "int" },
	// 		"Click Throughs": { yoy: true, dataType: "int", display: true },
	// 		Sales: { yoy: true, dataType: "currency" },
	// 		"# of Sales": { yoy: true, dataType: "int", display: true },
	// 		"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
	// 		"Mobile Sales": { yoy: true, dataType: "currency" },
	// 		"# of Adjustments": { yoy: true, dataType: "int", display: true },
	// 		"New Customers": { yoy: true, dataType: "int", display: false },
	// 		"New Customer Sales": { yoy: true, dataType: "currency" },
	// 		Commissions: { yoy: true, dataType: "currency" },
	// 		Incentives: { yoy: true, dataType: "currency", display: true },
	// 		"Network Commissions": { yoy: true, dataType: "currency" },
	// 		"Conversion Rate": { yoy: false, dataType: "percent" },
	// 		"Average Sale Amount": { yoy: true, dataType: "currency" },
	// 		"New Customer %": { yoy: true, dataType: "percent" },
	// 		"Click Through Rate": { yoy: true, dataType: "percent" },
	// 	},
	// },
	Performance_Summary_By_Sub_Affiliate_Partners: {
		id: 96,
		inReport: true,
		sortBy: "Sales",
		joinKey: "Sub Affiliate Domain",
		headers: {
			"CPC Earnings": { yoy: true, dataType: "currency" },
			"Network CPC Earnings": { yoy: true, dataType: "currency" },
			"Affiliate Id": { yoy: false, dataType: "string" },
			"Sub Affiliate Domain": { yoy: false, dataType: "string" },
			"Affiliate Name": { yoy: false, dataType: "string" },
			Affiliate: { yoy: false, dataType: "string", display: false },
			"Click Throughs": { yoy: true, dataType: "int", display: true },
			Sales: { yoy: true, dataType: "currency" },
			"Gross Sales": { yoy: true, dataType: "currency" },
			"# of Sales": { yoy: true, dataType: "int", display: true },
			"# of Mobile Sales": { yoy: true, dataType: "int", display: true },
			"Mobile Sales": { yoy: true, dataType: "currency" },
			"# of Adjustments": { yoy: true, dataType: "int", display: true },
			"New Customers": { yoy: true, dataType: "int", display: false },
			"New Customer Sales": { yoy: true, dataType: "currency" },
			Commissions: { yoy: true, dataType: "currency" },
			Incentives: { yoy: true, dataType: "currency" },
			"Network Commissions": { yoy: true, dataType: "currency" },
			"Conversion Rate": { yoy: false, dataType: "percent" },
			"Average Sale Amount": { yoy: true, dataType: "currency" },
			"New Customer %": { yoy: true, dataType: "percent" },
			"Click Through Rate": { yoy: true, dataType: "percent" },
			Merchant: { yoy: false, dataType: "string" },
			"Affiliate Tags": { yoy: false, dataType: "string" },
		},
	},

	Product_Sold: {
		id: 18,
		inReport: true,
		sortBy: "Total Product Sale Quantity",
		joinKey: "Product Name",
		headers: {
			"Brand Name": { yoy: false, dataType: "string" },
			Category: { yoy: false, dataType: "string" },
			Department: { yoy: false, dataType: "string" },
			Merchant: { yoy: false, dataType: "string" },
			"Mobile Sale Count ": { yoy: true, dataType: "currency" },
			"Product Name": { yoy: false, dataType: "string" },
			"Product SKU": { yoy: false, dataType: "string" },
			"Sale Count ": { yoy: true, dataType: "currency" },
			Store: { yoy: false, dataType: "string" },
			"Sub Category": { yoy: false, dataType: "string" },
			"Total Product Sale Amount": { yoy: true, dataType: "currency" },
			"Total Product Sale Quantity": { yoy: true, dataType: "int" },
		},
	},
	// Outlet_Summary: {
	// 	id: 90,
	// 	inReport: true,
	// 	sortBy: "Store Name",
	// 	headers: {
	// 		"Store Name": { yoy: false, dataType: "string" },
	// 		"# Sales": { yoy: true, dataType: "int" },
	// 		Qty: { yoy: true, dataType: "int" },
	// 		Mobile: { yoy: true, dataType: "currency" },
	// 		Returns: { yoy: true, dataType: "currency" },
	// 		Revenue: { yoy: true, dataType: "currency" },
	// 		"Affiliate Commission": { yoy: true, dataType: "currency" },
	// 		"Network Commission": { yoy: true, dataType: "currency" },
	// 		"Total Commission": { yoy: true, dataType: "currency" },
	// 	},
	// },
	Sales_Commissions_Detail: { id: 8, inReport: true },
	// Performance_Summary_By_Custom_Tracking_Code: {
	// 	id: 22,
	// 	inReport: false,
	// },
	// Performance_Summary_by_Affiliate_Tag_Group: { id: 25, inReport: false },
};
export const otherReports = {
	// REMOVED REPORT ELEMENTS >>Add as neccessary
	// Performance_Summary_By_Week: { id: 50, inReport: false },
	// Calendar_Period_Trending: { id: 63, inReport: false },
	// Calendar_Period_Trending_By_Affiliate: { id: 65, inReport: false },
	// Calendar_Period_Trending_By_Affiliate_Website: {
	// 	id: 66,
	// 	inReport: false,
	// },
	// Rolling_Period_Trending: { id: 67, inReport: false },
	// Rolling_Period_Trending_By_Affiliate: { id: 69, inReport: false },
	// Rolling_Period_Trending_By_Affiliate_Website: {
	// 	id: 70,
	// 	inReport: false,
	// },
	// Affiliate_Application_Approvals: { id: 85, inReport: false },
	// Ad_Impressions_Summary: { id: 2, inReport: false },
	// Ad_Impressions_Detail: { id: 3, inReport: false },
	// Click_Throughs_Summary: { id: 5, inReport: false },
	// Click_Throughs_Detail: { id: 6, inReport: false },
	// Referral_Domain_By_Affiliate: { id: 79, inReport: false },
	// Last_Click_Through_to_Sale_Summary: { id: 72, inReport: false },
	// First_Click_Through_to_Sale_Summary: { id: 83, inReport: false },
	//
	// Sale_Hit_Tracking_Trails: { id: 19, inReport: false },
	// Datafeed_Download_Summary: { id: 16, inReport: false },
	// Invalid_Affiliate_Links: { id: 23, inReport: false },
	// Performance_Summary_By_Discount: { id: 100, inReport: false },
	// Performance_Summary_By_Ad_Tool: { id: 9, inReport: false },
};
